let fareClassTypeOptions = require("json!../static/fareClassType.json");

const $inject = [];
const fareClassTypeService = function () {
  let service = {};

  service.get = function get() {
    return fareClassTypeOptions;
  };

  return service;
};

fareClassTypeService.$inject = $inject;

export default fareClassTypeService;


// WEBPACK FOOTER //
// ./src/services/fareClassTypeService.js